module.exports = __webpack_public_path__ + "static/media/coach-header.b71e20ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coach-header.jpg
// module id = 1349
// module chunks = 0